// User Profile
export const VIEW_USER_PROFILE  = "VIEW_USER_PROFILE";
export const SELECTED_STAFF_MEMBER = "SELECTED_STAFF_MEMBER"